<template lang="html">
  <div class="container-scroller flexbox-container">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex  auth auth-img-bg">
        <div class="row flex-grow">
          <div class="col-lg-12  align-items-center justify-content-center">
            <div class="m-0 justify-content-center row">
                <div class="d-flex justify-content-center col-sm-8 col-md-8 col-lg-10 col-xl-10">
                  <div class="bg-authentication login-card rounded-0 mb-0 w-100 card">
                    <div class="m-0 row">
                      <div class="p-0 col-md-12 col-lg-12">
                        <div class="rounded-0 mb-0 px-2 login-tabs-container" style="background:black !important">
                          <div class="auth-form-transparent text-left p-3 login">
                            <h2 style='color: white; font-size: 50px; font-weight: 400;'>{{lang == "ru" ? "Вход":"LOGIN"}}</h2>
                            <br/>
                            <br/>
                            <h6 class="font-weight-light" style='font-size: 18px; color: #FFFFFF;'>{{lang=="ru" ? "С возвращением!" : "Welcome back!"}}</h6>
                            <h6 class="font-weight-light" style='font-size: 18px; color: #FFFFFF;'>{{lang=="ru" ? "Рады видеть Вас снова!" : "We are glad to see you again!"}}</h6>
                            <h6 class="font-weight-light"  :class='errorText ? "errorText" : "invisible"'>{{errorText}}</h6>
                            <br/>
                            <form class="pt-3" autocomplete="off">
                              <div class="form-group">
                                <label style="font-size: 22px; color: white; opacity: 0.55;">{{email_text}}</label>
                                <div class="input-group">
                                  <!-- <div class="input-group-prepend bg-transparent">
                                    <span class="input-group-text bg-transparent border-right-0">
                                      <i class="mdi mdi-account-outline text-primary"></i>
                                    </span>
                                  </div> -->
                                  <input type="email" class="form-control form-control-lg border-left-0 input-auth" autocomplete="off"  v-model='email' v-on:keyup.enter='login'>
                                </div>
                              </div>
                              <div class="form-group" style="margin-top: 50px">
                                <label style="font-size: 22px; color: white; opacity: 0.55;">{{password_text}}</label>
                                <div class="input-group">
                                  <!-- <div class="input-group-prepend bg-transparent">
                                    <span class="input-group-text bg-transparent border-right-0">
                                      <i class="mdi mdi-lock-outline text-primary"></i>
                                    </span>
                                  </div> -->
                                  <input type="password" class="form-control form-control-lg border-left-0 input-auth"  v-model='password' v-on:keyup.enter='login'>
                                </div>
                              </div>
                              <div class="my-2 d-flex justify-content-end align-items-center">
                                <router-link to='/forgot-password' class="auth-link text-black" style="color: white; font-size: 18px;">{{lang=="ru"?"Забыли пароль?":"Forgot password?"}}</router-link>
                              </div>
                              <div class="my-3 d-flex justify-content-center mt-5">
                                <a class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" v-on:click='login'>{{lang=="ru"?"Войти":"LOGIN"}}</a>
                              </div>
                              <div 
                                id="signin_button" style="display: flex; justify-content: center"
                              >
                              </div>
                              <div class="text-center mt-4 font-weight-light" style="color: white; font-size: 18px;">
                                {{lang=="ru"?"Нет аккаунта? ":"Don't have an account? "}}<a href="https://tradingapp.pro/#info" class="text-primary">{{lang=="ru"?"Создать":"Sign Up"}}</a>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>
</template>

<script>
export default {
  props: ['bg-image']
}
</script>

<style lang="css" scoped>
  .flexbox-container {
        display: flex;
        align-items: center;
        height: 100vh;
        justify-content: center;
        overflow: hidden;
    }
  .content-wrapper {
    align-items: center;
    background-color: black !important;
}

@media(min-width: 1200px) {
  form {
    padding-left: 25%; 
    padding-right: 25%; 
  }
}
 .bg-authentication {
    background-color: black;
  }
  .card {
    background-color: black !important;
    margin-bottom: 2.2rem;
    border: none;
    border-radius: .5rem;
    box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
}
.p-0{
   background-color:black !important;
}
.input-auth {
  background:black !important; 
  border: none;
  border-bottom: 1px solid #FFFFFF;
  color: white !important;
  font-size: 20px !important;
  padding: 0;
  margin-top: 20px;

}

input:-webkit-autofill{
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: white !important;
}

input:focus {
    border-bottom: 1px solid #858585 !important;
}

.auth-form-btn {
  width: 236px;
  text-align: center;
  color: black !important;
  background: white !important;
  border: none;
  border-radius: 0;
}

</style>
<script>
export default {
  mounted() {
    window.addEventListener('load', () => {
        window.google.accounts.id.initialize({
            client_id: "1012521711276-gp1lvs9lj85nbela598vecavilimuld7.apps.googleusercontent.com",
            callback: this.handleCredentialResponse
        });
        window.google.accounts.id.renderButton(
            document.getElementById("signin_button"),
            { theme: "outline", size: "large" }  // customization attributes
        );
    })
  },
  data () {
    return {
      email: '',
      password: '',
      password_text:'',
      errorText: null,
      email_text:"Email",
      lang:'en',
      renderParams: {
          width: 250,
          height: 50,
          longtitle: true
      }
    }
  },
  created () {
    this.lang = this.$cookie.get('lang');
    if(this.lang=="ru"){
      this.email_text="Почта";
    }
    this.confirm();
  },
  methods: {
    async handleCredentialResponse(googleUser) {
      this.axios.post('/google_auth', {
        token: googleUser.credential
      }, {withCredentials: true}).then((response) => {
        response = response.data
        console.log(response);
          if (response.success) {
            document.cookie = 'token=' + response.token + ';path=/;domain=tradingapp.pro;'
            document.cookie = 'updated=false;path=/;domain=tradingapp.pro;'
            this.$router.push('/dashboard/overview')
          } else {
            this.errorText = response.message
          }
      })
    },

    confirm(){
      var query=this.$route.query.status;
      var update_status = this.$cookie.get('updated');
      if(update_status == 'true' || query=="new"){
        this.password_text = "New password";
        if(this.lang=="ru"){
          this.password_text = "Новый пароль";
        }
      }else{
         this.password_text = "Password";
          if(this.lang=="ru"){
            this.password_text = "Пароль";
          }
      }
    },

    login () {
      this.errorText = null
      this.axios.get('/login', {params: {email: this.email, password: this.password}})
        .then((response) => {
          response = response.data
          console.log(response)
          if (response.success) {
            // this.$root.$bvToast.toast("We are glad to welcome you to our platform. Our main function is auto trading. You can choose the strategies you like in the 'Bots Market'  and connect your account on Binance in 'Account settings'.  Enter the amount of USDT that you want the bot to trade in 'Properties'  by choosing a strategy. You can also experiment with settings and timeframes, but the suggested options are some of the most effective. Our simple interface shouldn't give you any problems, but if something is not clear feel free to ask any questions.", {
            //   title: 'Hello!',
            //   variant: 'success',
            //   solid: true
            // })
            document.cookie = 'token=' + response.token + ';path=/;domain=tradingapp.pro;'
            document.cookie = 'updated=false;path=/;domain=tradingapp.pro;'

            this.$router.push('/dashboard/overview')
          } else {
            this.errorText = response.message
          }
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .errorText {
    color: red
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue